// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers/index.js"
import TC from "@rolemodel/turbo-confirm"

TC.start()
